var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center", attrs: { id: "page-not-found" } },
    [
      _c("h1", [_vm._v("404")]),
      _vm._v(" "),
      _c("h2", [_vm._v("Oops! Page not found")]),
      _vm._v(" "),
      _c(
        "router-link",
        { staticClass: "btn btn-primary btn-go-to-home", attrs: { to: "/" } },
        [_vm._v("Go to home")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }